import { render, staticRenderFns } from "./ConfirmLoginOTP.vue?vue&type=template&id=13e3c90e&scoped=true"
import script from "./ConfirmLoginOTP.vue?vue&type=script&lang=js"
export * from "./ConfirmLoginOTP.vue?vue&type=script&lang=js"
import style0 from "./ConfirmLoginOTP.vue?vue&type=style&index=0&id=13e3c90e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e3c90e",
  null
  
)

export default component.exports